export default {
      id: "Icon--grid-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--grid",
      toString: function () {
        return this.url;
      }
    }